<template>
  <div class="contianer">
    <page-header from="index"></page-header>
    <div class="main">
      <search from="index"></search>
      <div class="section feature-section">
        <div class="section-container">
          <div class="func-section dashboard">
            <div class="dashboard-item row">
              <p class="dashboard__key">当前区块高度</p>
              <p class="dashboard__value">{{ home.number }}</p>
              <p class="dashboard__desc">最新的</p>
            </div>
            <div class="dashboard-item">
              <p class="dashboard__key">累积交易笔数</p>
              <p class="dashboard__value">{{ home.total_transactions }}</p>
              <p class="dashboard__desc">全部的</p>
              <img class="dashboard__img" src="../../assets/trade.png" />
            </div>
            <div class="dashboard-item">
              <p class="dashboard__key">平均出块时间</p>
              <p class="dashboard__value">{{ home.average_block_time }}</p>
              <p class="dashboard__desc">正常的</p>
              <img class="dashboard__img" src="../../assets/speed.png" />
            </div>
            <div class="dashboard-item">
              <p class="dashboard__key">合约数量</p>
              <p class="dashboard__value">{{ home.total_contracts }}</p>
              <p class="dashboard__desc">全部的</p>
              <img class="dashboard__img" src="../../assets/contract.png" />
            </div>
            <div class="dashboard-item">
              <p class="dashboard__key">链账户地址数</p>
              <p class="dashboard__value">{{ home.total_accounts }}</p>
              <p class="dashboard__desc">全部的</p>
              <img class="dashboard__img" src="../../assets/addr.png" />
            </div>
          </div>
          <div class="func-section trade-chart">
            <p class="trade-chart-title">交易历史最近14天</p>
            <div id="trade-chart"></div>
          </div>
          <div class="func-section record-section">
            <div class="func-section-title">
              <p class="title">最新区块</p>
              <p class="desc">3s后自动刷新</p>
            </div>
            <div class="record-list record--block">
              <div
                v-show="index < 8"
                class="record move"
                v-for="(item, index) in blockFrontList"
                :key="item.number"
                :class="[{ 'enter-from': item.isNew }]"
              >
                <div class="record-img">
                  <img src="../../assets/icon_bk.png" alt="" srcset="" />
                </div>
                <div class="record-info">
                  <div>
                    <p class="record__title">#{{ item.number }}</p>
                    <p class="record__time">{{ item.time }}秒前</p>
                  </div>
                  <p class="record__trade-num">
                    {{ item.transaction_count }}笔交易
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="func-section record-section">
            <div class="func-section-title">
              <p class="title">最近上链</p>
              <p class="desc">3s后自动刷新</p>
            </div>
            <div class="record-list">
              <div
                class="record"
                v-for="item in transFrontList"
                :key="item.tx_id"
              >
                <div class="record-img">
                  <img src="../../assets/icon_circle.png" alt="" srcset="" />
                </div>
                <div class="record-info">
                  <div class="left-info">
                    <a
                      class="record__title link-con"
                      href="javascript:void(0)"
                      :title="item.tx_id"
                      @click="reloadPage('trade_hash', item.tx_id)"
                      >{{ item.tx_id }}
                    </a>
                    <p class="record__time">{{ item.time | showTime }}</p>
                  </div>
                  <div class="from-to">
                    <p>从</p>
                    <p>到</p>
                  </div>
                  <div class="right-info">
                    <a
                      class="link-con"
                      href="javascript:void(0)"
                      :title="item.addr"
                      @click="reloadPage('addr', item.addr)"
                      >{{ item.addr }}</a
                    >
                    <a
                      class="link-con"
                      href="javascript:void(0)"
                      :title="item.to_addr"
                      @click="reloadPage('addr', item.to_addr)"
                      >{{ item.to_addr }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer from="index"></page-footer>
  </div>
</template>

<script>
import pageHeader from "@/components/page-header";
import pageFooter from "@/components/page-footer";
import search from "@/components/search";
import { formatNum } from "@/utils/comm.js";

import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { LineChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition]);

export default {
  name: "index",
  components: {
    pageHeader,
    pageFooter,
    search
  },
  data() {
    return {
      interval: null,
      home: {},
      blockFrontList: [],
      transFrontList: [],
      myChart: null
    };
  },
  filters: {
    showTime(time) {
      let d = 0,
        h = 0,
        m = 0,
        s = 0;
      s = time % 60;
      if (time === s) {
        return s + "秒前";
      }
      m = Math.floor(time / 60);
      if (m <= 60) {
        return m + "分前";
      }
      h = Math.floor(m / 60);
      if (h <= 24) {
        return h + "小时前";
      }
      d = Math.floor(h / 24);
      return d + "天前";
    }
  },
  mounted() {
    this.homeInfo();
    this.transChart14();
    this.interval = setInterval(() => {
      this.homeInfo();
    }, 3000);

    this.initCharts();
    window.addEventListener("resize", this.debounce(this.resizeChart, 500));
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
  methods: {
    // 防抖
    debounce(fn, delay) {
      let timer = null;
      return function() {
        clearTimeout(timer);
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    },
    // 图标尺寸重置
    resizeChart() {
      this.myChart.resize();
    },
    initCharts(labels, values) {
      var chartDom = document.getElementById("trade-chart");
      this.myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ["#1777FF"],
        tooltip: {
          // 触发类型，默认数据触发，可选为：'item' | 'axis'
          trigger: "item",
          show: true,
          axisPointer: {
            // 全局配置 十字准星指示器
            type: "cross"
          }
        },
        xAxis: {
          type: "category",
          data: labels
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // 使用 formatter 函数格式化标签文本
            formatter: "{value}K" // 在这里设置单位
          }
        },
        series: [
          {
            data: values,
            type: "line",
            smooth: true
          }
        ]
      };

      option && this.myChart.setOption(option);
    },
    reloadPage(type, key) {
      this.$router.push(`search?type=${type}&key=${key}`);
    },
    transChart14() {
      this.$api.transChart14().then(res => {
        res = res.data;
        if (res.code == 1) {
          let data = res.data;
          let labels = [];
          let values = [];
          data.forEach(item => {
            labels.push(item.date);
            values.push(item.total_transactions / 1000);
          });
          this.initCharts(labels, values);
        }
      });
    },
    homeInfo() {
      this.$api.homeInfo().then(res => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          let data = res.data;
          data.number = formatNum(data.number);
          data.total_transactions = formatNum(data.total_transactions);
          data.total_contracts = formatNum(data.total_contracts);
          data.total_accounts = formatNum(data.total_accounts);
          if (this.home.number != data.number) {
            this.blockFront8();
            this.transFront8();
          }
          this.home = data || {};
        } else {
          this.home = {};
        }
      });
    },
    transFront8() {
      this.$api.transFront8().then(res => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          let data = res.data || [];
          let newTime = new Date().getTime();
          data[data.length - 1].isOld = true;
          this.transFrontList = data.map(item => {
            let time = Math.ceil((newTime - item.block_time) / 1000);
            if (time < 0) {
              time = 0;
            }
            item.time = time;
            return item;
          });
        } else {
          this.transFrontList = [];
        }
      });
    },
    blockFront8() {
      this.$api.blockFront8().then(res => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          let data = res.data || [];
          let newTime = new Date().getTime();
          data[data.length - 1].isOld = true;
          this.blockFrontList = data.map(item => {
            let time = Math.ceil((newTime - item.timestamp) / 1000);
            if (time < 0) {
              time = 0;
            }
            item.time = time;
            return item;
          });
        } else {
          this.blockFrontList = [];
        }
      });
    }
  }
};
</script>

<style scoped>
.section.feature-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border: none;
}

.section-container {
  margin-top: -26px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.func-section {
  margin-bottom: 45px;
  width: calc(50% - 9px);
}

.section.feature-section .dashboard {
  display: flex;
  justify-content: space-between;
  justify-content: space-between;
  flex-wrap: wrap;
}

.section.feature-section .dashboard-item {
  position: relative;
  margin-top: 18px;
  width: calc(50% - 9px);
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 140px;
}

.section.feature-section .dashboard-item.row {
  margin-top: 0;
  width: 100%;
}

.section.feature-section .dashboard-item.row .dashboard__value {
  color: #1777ff;
  font-size: 25px;
}

.trade-chart {
  position: relative;
  padding: 32px 0 32px 20px;
  background: #fff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: 1px solid #e8eaf3;
  box-sizing: border-box;
  height: 456px;
}

.trade-chart-title {
  margin-left: 15px;
  font-size: 14px;
  color: #333;
}

#trade-chart {
  width: 100%;
  height: 400px;
}

.section.feature-section .dashboard__value {
  margin-top: 18px;
  font-size: 20px;
  color: #333333;
  line-height: 29px;
  font-weight: bold;
}

.section.feature-section .dashboard__img {
  position: absolute;
  right: 28px;
  top: 50%;
  margin-top: -29px;
  width: 58px;
  height: 58px;
}

.section.feature-section .dashboard__desc {
  margin-top: 10px;
  font-size: 14px;
  color: #91979d;
  line-height: 20px;
}

.section.feature-section .dashboard__key {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.record-section {
  position: relative;
}

.record-section::after {
  content: "";
  height: 287px;
  width: 100%;
  position: absolute;
  background: linear-gradient(
    180deg,
    rgba(246, 249, 252, 0) 39.19%,
    #f6f9fc 100%
  );
  bottom: 0;
  left: 0;
  pointer-events: none;
  display: none;
}

.record-list {
  height: 727px;
  padding: 20px 28px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(62, 75, 93, 0.1);
  border-radius: 9px;
  box-sizing: border-box;
}

.record {
  height: 85px;
  display: flex;
  align-items: center;
  transform-origin: center;
  border-bottom: 1px dashed #e0e4e8;
}

.record.enter-active,
.record.leave-active,
.record.move {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0s,
    opacity 0.4s ease 0s;
  will-change: transform;
}

.record.enter-from,
.record.leave-to {
  transform: scale(0.5);
}

.record.leave-to {
  opacity: 0;
}

.record.leave-active {
  display: none;
}

.record:last-child {
  transform-origin: center;
  border-bottom: none;
}

.record-img {
  flex-shrink: 0;
  width: 43px;
  height: 43px;
}

.record-img img {
  width: 100%;
  height: 100%;
}

.record-info {
  width: 100px;
  flex: 1;
  margin-left: 15px;
}

.record-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.record__title,
.record__time {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  font-size: 14px;
  color: #000000;
  cursor: default;
}

.left-info,
.right-info {
  flex-shrink: 1;
  flex-grow: 1;
  width: 30%;
}

.from-to {
  width: 50px;
  text-align: center;
  flex-shrink: 0;
  font-size: 14px;
  color: #333333;
}

.left-info,
.right-info,
.from-to {
  line-height: 2;
}

.record__time {
  font-size: 12px;
  color: #7a8399;
}

.record__time.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.link-con {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}

.record__trade-num {
  font-size: 14px;
  color: #1777ff;
}

@media (max-width: 1199px) {
  .section.feature-section {
    width: 95% !important;
    margin-left: auto;
    margin-right: auto;
  }
  .func-section {
    width: 100%;
  }
}

@media (max-width: 800px) {
  .section.feature-section .dashboard {
    position: inherit;
    left: 0;
    transform: none;
  }

  .section.feature-section .dashboard__img {
    right: 20px;
    margin-top: -24px;
    width: 48px;
    height: 48px;
  }

  .func-section {
    margin-bottom: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue